var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBtnEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.2458 4.754C19.0035 4.51281 18.7159 4.32199 18.3995 4.19259C18.0831 4.06318 17.7442 3.99775 17.4024 4.00006C17.0606 4.00237 16.7226 4.07239 16.408 4.20607C16.0934 4.33975 15.8084 4.53444 15.5694 4.77889L5.25863 15.0897L4 19.9998L8.91007 18.7404L19.2209 8.42962C19.4654 8.19079 19.6601 7.90586 19.7939 7.5913C19.9276 7.27675 19.9976 6.9388 19.9999 6.59701C20.0023 6.25521 19.9368 5.91635 19.8073 5.60001C19.6779 5.28367 19.487 4.99612 19.2458 4.754V4.754Z",
    stroke: "#172664",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2754 5.07422L18.9261 8.72495",
    stroke: "#172664",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.25928 15.0879L8.91357 18.7358",
    stroke: "#172664",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtnEdit);
export default __webpack_public_path__ + "static/media/btn_edit.58bc219521c329e2cceafa76c2cc2103.svg";
export { ForwardRef as ReactComponent };